// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2SK_W","option":"styles_option__oDXI9","active":"styles_active__weZsM"};